import debug from 'debug'

export default debug('debug')



// WEBPACK FOOTER //
// ../source/utilities/debug.js